










import Vue from "vue";
import Component from "vue-class-component";
import { LeadService } from "@/services/lead.service";
import { Prop, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: string | null;
}

@Component
export default class ComboMotivoLead extends Vue {
  @Prop() readonly value!: string | null;
  loading = false;
  motivoLead: ComboItem | null = null;
  items: ComboItem[] = [];

  @Prop({ required: true }) readonly label!: string;
  @Prop({ default: () => [] }) readonly rules!: Array<
    (v: any) => string | undefined
  >;
  @Prop({ required: false, default: () => undefined, type: Boolean })
  readonly ativos?: boolean;

  @Watch("value", { immediate: true })
  onValueChange(val: string | null) {
    val = "" + val;
    this.motivoLead = this.items.find((x) => x.value == val) ?? null;
  }

  @Watch("motivoLead")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  async fetchMotivoLead() {
    this.loading = true;
    this.items = await LeadService.obterMotivoLead(this.ativos).then((res) =>
      res.map((x) => ({
        text: x.nome,
        value: "" + x.idMotivoLead,
      }))
    );

    this.items.unshift({ text: "", value: null });

    if (this.value) {
      this.motivoLead = this.items.find((x) => x.value == this.value) || null;
    }

    this.loading = false;
  }

  mounted() {
    this.fetchMotivoLead();
  }
}
